import css from 'styled-jsx/css';
import Theme, { fontSizes, colors, zIndexLevels } from '../../themes';

export default css`
  header {
    align-items: flex-start;
    display: flex;
    padding: 10px;
  }

  header.cars {
    background: ${Theme.cars.main};
  }

  header.jobs {
    background: ${Theme.jobs.main};
  }

  header.homes {
    background: ${Theme.homes.main};
  }

  header.products {
    background: ${Theme.products.main};
  }

  form :global(input) {
    padding: 0.5em;
    padding-right: 2em;
    color: #fff;
    border: 0;
    border-radius: ${Theme.global.borderRadius};
    width: 100%;
    background: rgba(0, 0, 0, 0.25);
    font-size: 19px;
  }

  form :global(input::placeholder) {
    color: #fff;
    opacity: 0.5;
  }

  header .icon :global(svg) {
    width: 59px;
    height: 36px;
    margin: 0 8px;
  }

  .icon-wrapper {
    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  }

  h1 {
    align-self: center;
    color: ${colors.grayExtraLight};
    flex-grow: 1;
    font-size: ${fontSizes.big};
    font-weight: 500;
    margin: 0 10px;
    position: relative;
    text-align: left;
  }

  form {
    align-self: center;
    flex-grow: 1;
    position: relative;
    margin: 0 0 0 10px;
  }

  :global(.rtl) form {
    margin: 0 10px 0 0;
  }

  :global(.rtl) form :global(input) {
    padding-right: 0.65em;
    padding-left: 2em;
  }

  header button {
    background: none;
    border: 0;
    position: absolute;
    top: 8px;
    right: 3px;
    z-index: ${zIndexLevels.medium1};
  }

  :global(.rtl) header {
    padding: 11px;
  }

  :global(.rtl) .logo {
    right: 10px;
    left: auto;
  }

  :global(.rtl) header button {
    left: 13px;
    right: auto;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Header/styles.js